import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import { login as apiLogin } from "../lib/api";
import { Button, Input, FormField, Card, CardContent } from "../components/ui";
import { Car } from "lucide-react";
import { toast } from "sonner";

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "");

export default function Login() {
  const { login, empresa } = useContext(AuthContext);
  const navigate   = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await apiLogin(form.email, form.password);
      login(data.user, data.access_token);
      navigate("/dashboard");
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      // 403 = sistema suspendido (falta de pago); mostramos el mensaje del backend.
      if (status === 403 && detail) {
        toast.error(detail, { duration: 8000 });
      } else {
        toast.error("Credenciales incorrectas");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8 gap-3">
          {empresa?.logo_url
            ? <img src={`${API_BASE}${empresa.logo_url}`} alt="Logo" className="h-20 w-auto object-contain" />
            : <div className="w-14 h-14 rounded-2xl bg-primary flex items-center justify-center shadow-lg">
                <Car className="w-8 h-8 text-primary-foreground" />
              </div>
          }
          <div className="text-center">
            <h1 className="font-display font-bold text-2xl">{empresa?.nombre || "Vision Motors"}</h1>
            <p className="text-sm text-muted-foreground">Sistema de Gestión</p>
          </div>
        </div>

        <Card>
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <FormField label="Email">
                <Input
                  type="email"
                  placeholder="admin@visionmotors.com"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  autoFocus
                  required
                />
              </FormField>
              <FormField label="Contraseña">
                <Input
                  type="password"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
              </FormField>
              <Button type="submit" loading={loading} className="w-full mt-2">
                Iniciar sesión
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-muted-foreground mt-4">
          v2.0 — {empresa?.nombre || "Vision Motors"} © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
